import React, { useEffect, useState } from 'react';
import styles from '../styles/wizards/AttachSpecificationToPlanWizard.scss';
import AddSpecificationIcon from '../assets/images/add-specification-to-plan-60x60.svg';
import { __, setTableParams, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import { connect } from 'react-redux';
import {
  attachSpecificationToPlanRevision,
  listPossiblePlanRevisionSpecifications,
} from '../redux/actions/table/current_set_plans';
import {
  attachSpecificationToPlanVersion,
  listPossiblePlanVersionSpecifications,
} from '../redux/actions/table/working_set_plans';
import AddExistingSpecificationForm from '../forms/add_existing_specification_form/AddExistingSpecificationForm';
import { updateTool } from '../redux/actions/canvas_editor';

const AttachSpecificationToPlanWizard = ({
  match,
  current_set_plans,
  working_set_plans,
  onClose,
  application_language_id,
}) => {
  const [possibleSpecificationCodes, setPossibleSpecificationCodes] = useState(
    []
  );

  const flyout =
    match.path === '/plans/versions/:plan_version'
      ? working_set_plans['flyout']
      : current_set_plans['flyout'];

  useEffect(() => {
    if (match.path === '/plans/versions/:plan_version') {
      listPossiblePlanVersionSpecifications(match.params.plan_version).then(
        ({ response }) => {
          setPossibleSpecificationCodes(response.data);
        }
      );
    }

    if (match.path === '/plans/revisions/:plan_revision') {
      listPossiblePlanRevisionSpecifications(match.params.plan_revision).then(
        ({ response }) => {
          setPossibleSpecificationCodes(response.data);
        }
      );
    }
  }, []);

  const _handleOnClose = () => {
    setNotification(__('wizard.attach-specification.confirm'));

    onClose();

    updateTool({ tool: 'hand' });
  };

  const handleSubmit = (formData) => {
    if (match.path === '/plans/revisions/:plan_revision') {
      return validateForm(
        attachSpecificationToPlanRevision(match.params.plan_revision, {
          ...formData,
          x: current_set_plans.x,
          y: current_set_plans.y,
        }).then(({ response }) => {
          setTableParams('current_set_plans', {
            specification_code_id: response.data.id,
            x: current_set_plans.x,
            y: current_set_plans.y,
          });

          _handleOnClose();
        })
      );
    }

    if (match.path === '/plans/versions/:plan_version') {
      return validateForm(
        attachSpecificationToPlanVersion(match.params.plan_version, {
          ...formData,
          x: working_set_plans.x,
          y: working_set_plans.y,
          //existing_specification_id: specification_id,
        }).then(({ response }) => {
          setTableParams('working_set_plans', {
            specification_code_id: response.data.id,
            x: working_set_plans.x,
            y: working_set_plans.y,
            // old_specification_id: specification_id,
          });
          _handleOnClose();
        })
      );
    }
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>
            {__('wizard.add-specification.title.attach-specification')}
          </span>
          <span>
            {__('wizard.add-specification.subtitle.attach-specification')}
          </span>
        </div>
        <div className={styles.right}>
          <AddSpecificationIcon />
        </div>
      </div>

      <div className={styles.body}>
        {possibleSpecificationCodes && (
          <AddExistingSpecificationForm
            onSubmit={handleSubmit}
            possibleSpecificationCodes={possibleSpecificationCodes}
            project_languages={flyout?.project_languages}
            onClose={onClose}
            application_language_id={application_language_id}
          />
        )}
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    working_set_plans: state.table['working_set_plans'],
    current_set_plans: state.table['current_set_plans'],
    application_language_id: state.auth.language_id,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(subscribe(Localization, 'localization')(AttachSpecificationToPlanWizard))
);
